import { render } from "./InvestmentCalculatorPage.vue?vue&type=template&id=60a84114&scoped=true"
import script from "./InvestmentCalculatorPage.vue?vue&type=script&lang=js"
export * from "./InvestmentCalculatorPage.vue?vue&type=script&lang=js"

import "./InvestmentCalculatorPage.vue?vue&type=style&index=0&id=60a84114&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a84114"]])

export default __exports__